import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface UIState {
  isMobileMenuOpen: boolean
  isScrolled: boolean
  activeModal: string | null
  toastMessage: string | null
  toastType: 'success' | 'error' | 'info' | null
}

const initialState: UIState = {
  isMobileMenuOpen: false,
  isScrolled: false,
  activeModal: null,
  toastMessage: null,
  toastType: null,
}

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    toggleMobileMenu: (state) => {
      state.isMobileMenuOpen = !state.isMobileMenuOpen
    },
    setMobileMenuOpen: (state, action: PayloadAction<boolean>) => {
      state.isMobileMenuOpen = action.payload
    },
    setScrolled: (state, action: PayloadAction<boolean>) => {
      state.isScrolled = action.payload
    },
    openModal: (state, action: PayloadAction<string>) => {
      state.activeModal = action.payload
    },
    closeModal: (state) => {
      state.activeModal = null
    },
    showToast: (state, action: PayloadAction<{ message: string; type: 'success' | 'error' | 'info' }>) => {
      state.toastMessage = action.payload.message
      state.toastType = action.payload.type
    },
    hideToast: (state) => {
      state.toastMessage = null
      state.toastType = null
    },
  },
})

export const {
  toggleMobileMenu,
  setMobileMenuOpen,
  setScrolled,
  openModal,
  closeModal,
  showToast,
  hideToast,
} = uiSlice.actions

export default uiSlice.reducer
